import { useMutation, useQueryClient } from 'react-query';
import { ITcoLocations } from 'types';
import { tcoLocationRequest, queryKeys } from 'utils';

export const usePostTcoMultipleLocations = (estimateId: string) => {
  const queryClient = useQueryClient();
  const queryKey = queryKeys({ estimateId }).filter.tcoLocations;

  const {
    mutate: postTcoMultipleLocation,
    isLoading: postTcoLocationLoading,
    isSuccess: postTcoLocationSuccess,
    isError: postTcoLocationError,
  } = useMutation<
    unknown,
    unknown,
    Partial<ITcoLocations> | Partial<ITcoLocations>[]
  >(
    async (payload) => {
      const batch = Array.isArray(payload) ? payload : [payload];
      const processedBatch: Partial<ITcoLocations>[] = batch.map((loc) => {
        const cleanedSelections =
          loc.underlaySelections?.map((sel: any) => {
            if (!sel.id || sel.id.startsWith('new-')) {
              const { id, locationId, ...rest } = sel;
              return rest;
            }
            return sel;
          }) ?? [];

        return {
          ...loc,
          underlaySelections: cleanedSelections,
        };
      });

      return tcoLocationRequest({
        method: 'POST',
        data: processedBatch,
      });
    },
    {
      onMutate: async (newPayload) => {
        await queryClient.cancelQueries(queryKey);

        const previous =
          queryClient.getQueryData<ITcoLocations[]>(queryKey) || [];
        return { previous };
      },
      onError: (_err, _newPayload, context) => {
        queryClient.setQueryData(queryKey, context);
      },
      onSettled: () => {
        queryClient.invalidateQueries(queryKey);
      },
    }
  );

  return {
    postTcoMultipleLocation,
    postTcoLocationLoading,
    postTcoLocationSuccess,
    postTcoLocationError,
  };
};
